<template>
  <section class="hero grd is-primary is-fullheight">
    <div class="hero-body">
      <div class="container">
<!--        <h1 class="title">-->
<!--          {{$t('header')}}-->
<!--        </h1>-->
<!--        <h2 class="subtitle">-->
<!--          {{$t('countdown', {s: countdown})}}-->
<!--        </h2>-->
        <div class="columns">
          <div class="column is-one-third">
            <vue-qrcode :options="{width:360}" :value="code"/>
          </div>
          <div class="column is-two-thirds">
            <img src="ws2.png" style="height:180px"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import VueQrcode from '@chenfengyuan/vue-qrcode';
  import * as njwt from 'njwt';

  export default {
    name: 'app',
    components: {VueQrcode},
    data() {
      return {
        timer: {},
        secret: process.env.VUE_APP_JWT_KEY || "guwno",
        tokenTimeout: 2,
        tokenExp: 75,
        countdown: 0,
        tokenValue: ""
      }
    },
    computed: {
      code() {
        return process.env.VUE_APP_TOKEN_URL + this.tokenValue;
      }
    },
    mounted() {
      this.generateToken()
      const timerToken = setInterval(this.generateToken, this.tokenTimeout * 1000)
      const timerCountdown = setInterval(this.updateCountdown, 1000);
    },
    methods: {
      generateToken() {
        const tk = njwt.create({"act": "ws", "event": "tablet"}, this.secret);
        tk.setExpiration(new Date().getTime() + (this.tokenExp * 1000));
        this.tokenValue = tk.compact();

        this.countdown = this.tokenTimeout;
      },
      updateCountdown() {
        this.countdown = this.countdown - 1;
      }
    }
  }
</script>

<style scoped>
  .is-primary {
    /*background: linear-gradient(45deg, #ff185c 0%, #19a8fe 100%) !important;*/
    background: black !important;
  }
</style>
